<template>
	<div style="height: 100%; background-color: #f4f4f5">
		<div class="info">
			<div class="t1">
				<svg
					v-if="order.orderState == 2"
					style="vertical-align: middle"
					t="1574154963539"
					viewBox="0 0 1024 1024"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					p-id="3670"
					width="24"
					height="24">
					<path
						d="M0 512C0 229.235 229.235 0 512 0s512 229.235 512 512-229.235 512-512 512S0 794.765 0 512z m419.31 194.63a35.31 35.31 0 0 0 49.4 1.272L804.228 395.97a35.31 35.31 0 0 0-48.075-51.73L447.03 633.786 301.903 484.14a35.31 35.31 0 1 0-50.688 49.17l168.113 173.32z"
						p-id="3671"
						fill="#005924"></path>
				</svg>
				<svg
					v-else-if="order.orderState == 4 || order.orderState == 3"
					style="vertical-align: middle"
					viewBox="0 0 1024 1024"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					p-id="6553"
					width="24"
					height="24">
					<path
						d="M549.044706 512l166.189176-166.249412a26.383059 26.383059 0 0 0 0-36.98447 26.383059 26.383059 0 0 0-37.044706 0L512 475.015529l-166.249412-166.249411a26.383059 26.383059 0 0 0-36.98447 0 26.383059 26.383059 0 0 0 0 37.044706L475.015529 512l-166.249411 166.249412a26.383059 26.383059 0 0 0 0 36.98447 26.383059 26.383059 0 0 0 37.044706 0L512 548.984471l166.249412 166.249411a26.383059 26.383059 0 0 0 36.98447 0 26.383059 26.383059 0 0 0 0-37.044706L548.984471 512zM512 1024a512 512 0 1 1 0-1024 512 512 0 0 1 0 1024z"
						fill="#E84335"
						p-id="6554"></path>
				</svg>
				<svg
					v-else
					style="vertical-align: middle"
					t="1646983540389"
					viewBox="0 0 1024 1024"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					p-id="5546"
					width="24"
					height="24">
					<path
						d="M512 992C246.912 992 32 777.088 32 512 32 246.912 246.912 32 512 32c265.088 0 480 214.912 480 480 0 265.088-214.912 480-480 480zM480 256v352a32 32 0 0 0 64 0V256a32 32 0 0 0-64 0z m-16 528a48 48 0 1 0 96 0 48 48 0 0 0-96 0z"
						p-id="5547"
						data-spm-anchor-id="a313x.7781069.0.i6"
						class="selected"
						fill="#efb336"></path>
				</svg>
				<span style="vertical-align: middle; margin-left: 10px" class="tips-larger">{{ order.orderStateDesc }}</span>
			</div>
			<div class="t1">
				<span style="vertical-align: middle">
					<span style="vertical-align: middle">
						{{ $t('result.paymoney') }}
						<span style="color: red; font-weight: bolder">{{ order.orderMoney }}</span>
						{{ $t('result.yuan') }}
					</span>
				</span>
			</div>
			<pay-detail :item="payInfo"></pay-detail>
			<pay-detail :item="orderDetail"></pay-detail>
			<pay-detail :item="ticketInfo" v-if="showTicket"></pay-detail>
		</div>
		<div class="nav-bottom">
			<van-button
				type="primary"
				size="small"
				square
				style="border-radius: 5px; width: 120px; background-color: #005423"
				@click="openDialog"
				v-show="showExport">
				发送凭据到邮箱
			</van-button>
			<van-button
				type="primary"
				size="small"
				square
				style="border-radius: 5px; width: 70px; background-color: #005423"
				@click="refresh"
				v-show="showRefresh">
				刷新状态
			</van-button>
			<van-button
				type="primary"
				size="small"
				plain
				square
				style="border-radius: 5px; margin-left: 30px; width: 70px; color: #005423"
				@click="close">
				关闭
			</van-button>
		</div>
		<!-- <pre-page v-if="closeButton" title="关 闭" @back="close"></pre-page>
        <pre-page v-else title="返 回" @back="toHome"></pre-page> -->
		<van-dialog
			title="邮箱地址"
			show-cancel-button
			show-confirm-button
			confirmButtonColor="#005423"
			v-model="showDialog"
			:beforeClose="onConfirm">
			<van-field
				v-model="sendToEmail"
				style="padding-left: 10px; width: 100%"
				placeholder="请填入邮箱地址"
				input-align="left"
				type="text"></van-field>
		</van-dialog>
	</div>
</template>
<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>
<script>
import log from 'utils/log'
import util from 'utils/util'
import apiChooseFee from 'api/choose-fee'
import apiAnonymousFee from 'api/anonymous-pay'
import prePage from 'components/pre-page/index'
import payDetail from './comps/index'
//import {Dialog} from "vant";

export default {
	name: 'pay_suc',
	components: {
		//prePage,
		payDetail
		//MobileButton
	},
	data() {
		return {
			order: {},
			payInfo: {
				name: '支付信息',
				details: []
			},
			orderDetail: {
				name: '订单明细',
				details: []
			},
			ticketInfo: {
				name: '票据信息',
				details: []
			},
			closeButton: false,
			showTicket: false,
			showExport: false,
			showRefresh: false,
			showDialog: false,
			sendToEmail: ''
		}
	},

	methods: {
		toHome() {
			this.$router.push({ path: '/home' })
		},
		close() {
			wx.closeWindow()
			// let isLppzApp = false
			// let ua = navigator.userAgent.toLowerCase()
			// let uaApp = ua ? ua.match(/BeStore/i) : ''
			// let uaAndroid = /android/i.test(ua)
			// let uaIos = /iphone|ipad|ipod/i.test(ua)
			// if (uaApp && uaApp.toString() === 'bestore') {
			//     isLppzApp = true
			// } else {
			//     isLppzApp = false
			// }
			// if (window.WeixinJSBridge) {
			//     window.WeixinJSBridge.call('closeWindow')
			// } else if (window.AlipayJSBridge) {
			//     window.AlipayJSBridge.call('closeWebview')
			// } else if (isLppzApp && uaAndroid) {
			//     window.obj.closePageLppzRequest('')
			// } else if (isLppzApp && uaIos) {
			//     window.webkit.messageHandlers.closePageLppzRequest.postMessage('')
			// }
		},
		openDialog() {
			this.showDialog = true
		},
		onConfirm(action, done) {
			if (action === 'cancel') {
				done()
			} else if (action === 'confirm') {
				let token = this.$route.query.token
				if (token) {
					token = util.ensureEncoded(token)
					apiChooseFee
						.sendEmail({ downloadToken: token, email: this.sendToEmail })
						.then(res => {
							this.$notify({
								type: 'success',
								message: '邮件已发送'
							})
							done()
						})
						.catch(err => {
							done()
						})
				} else {
					this.$notify({
						type: 'error',
						message: 'token不存在'
					})
				}
			}
		},
		refresh() {
			location.reload()
		},
		err() {
			this.$dialog
				.alert(this.$t('result.err'), '提示', {
					confirmButtonText: '确定',
					type: 'success'
				})
				.then(() => {
					this.$router.push({ path: '/home' })
				})
		},
		getModel(name, value, type = 'text') {
			return {
				name: name,
				value: value,
				type: type
			}
		}
	},
	mounted() {},
	created() {
		let order_no = this.$route.query.order_no
		this.closeButton = this.$route.query.close
		let type = this.$route.query.type
		let api = apiChooseFee
		if (type && type == '3') {
			api = apiAnonymousFee
		}
		if (order_no) {
			const param = {
				order_no: order_no,
				mch_id: this.$route.query.mch_id,
				out_trade_no: this.$route.query.out_trade_no,
				total_money: this.$route.query.total_money,
				pay_type: this.$route.query.pay_type,
				pay_time: this.$route.query.pay_time,
				pay_result: this.$route.query.pay_result,
				timestamp: this.$route.query.timestamp,
				sign: this.$route.query.sign
			}
			api.getOrderInfo(param).then(res => {
				let order = res.data
				this.order = order
				this.showExport = this.order.orderState == 2 ? true : false
				this.showRefresh = this.order.orderState == 1 ? true : false
				if (type && type == '3') {
					this.showExport = false
				}
				this.payInfo.details.push(this.getModel(this.$t('result.order.name'), order.mchName))
				this.payInfo.details.push(this.getModel(this.$t('result.order.no'), order.orderNo))
				this.payInfo.details.push(this.getModel(this.$t('result.order.paytime'), order.orderPayTime))
				order.orderDetailVOS.forEach(item => {
					if (item.ticketTypeId != null) {
						this.showTicket = true
					}
					let tmp = item.feeTerm == null ? item.itemName : item.itemName + '（' + item.feeTerm + '）'
					this.orderDetail.details.push(this.getModel(tmp, item.itemMoney, 'money'))
					this.orderDetail.details.push(this.getModel(this.$t('result.detail.remark') + '：', ' '))
					this.orderDetail.details.push(this.getModel('', item.remark, 'remark'))
				})
				this.ticketInfo.details.push(this.getModel(this.$t('result.ticket.title'), order.ticketTitle))
				this.ticketInfo.details.push(this.getModel(this.$t('result.ticket.idtype'), order.ticketNum))
				this.ticketInfo.details.push(this.getModel(this.$t('result.ticket.email'), order.ticketEmail))
			})
		} else {
			this.err()
		}
	}
}
</script>
<style lang="scss" scoped>
/deep/ .info {
	padding: 5px;
	padding-top: 10px;
	height: calc(100% - 50px);
	overflow-y: auto;
}

/deep/ .tips-larger {
	font-size: 18px;
}

/deep/ .tips-larger,
.tips-middle {
	font-weight: 600;
}

/deep/ .card-content {
	padding-top: 0px !important;
}

/deep/ .t1 {
	height: 40px;
	line-height: 40px;
	margin-left: 30%;
	text-align: left;
}

.nav-bottom {
	width: 100%;
	height: 50px;
	line-height: 40px;
	position: absolute;
	bottom: 0px;
	background-color: white;
	font-size: 16px;
	color: #005423;
	text-align: center;
}
</style>
